import { render, staticRenderFns } from "./CartSimple.vue?vue&type=template&id=2fd9674f&scoped=true"
import script from "./CartSimple.vue?vue&type=script&lang=js"
export * from "./CartSimple.vue?vue&type=script&lang=js"
import style0 from "./CartSimple.vue?vue&type=style&index=0&id=2fd9674f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd9674f",
  null
  
)

export default component.exports